import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { AiOutlineCalendar, AiOutlineCar, AiOutlineInstagram } from 'react-icons/ai';
import { Button, Stack } from '@chakra-ui/react';

import useSPH from '@hooks/useSPH';

dayjs.extend(utc);

function WeddingLocation() {
  const sph = useSPH();

  const handleClickGoogleMaps = () => {
    window.open(sph.urlMaps, '_blank');
  };

  /**
   * Generate link for Google Calendar
   * @returns {void}
   */
  const handleClickAddToCalendar = () => {
    const title = `${sph.title} - ${sph.desc}`;
    const finalURL = `text=${encodeURIComponent(title)}`;
    const location = `location=${sph.desc}`;

    const startDate = dayjs(sph.epochStart * 1000)
      .utc(true)
      .format('YYYYMMDDTHHmmss');
    const endDate = dayjs(sph.epochEnd * 1000)
      .utc(true)
      .format('YYYYMMDDTHHmmss');

    window.open(
      `https://www.google.com/calendar/render?action=TEMPLATE&${finalURL}&dates=${startDate}/${endDate}&${location}`,
      '_blank',
    );
  };

  return (
    <Stack direction="row" spacing={2} align="center">
      <Button
        leftIcon={<AiOutlineCalendar />}
        colorScheme="blackAlpha"
        bgColor="bgSecondary"
        fontWeight="normal"
        size="sm"
        onClick={handleClickAddToCalendar}
      >
        Remind Me
      </Button>
      <Button
        leftIcon={<AiOutlineCar />}
        colorScheme="blackAlpha"
        bgColor="bgSecondary"
        fontWeight="normal"
        size="sm"
        onClick={handleClickGoogleMaps}
      >
        Location
      </Button>
      <Button
        leftIcon={<AiOutlineInstagram />}
        colorScheme="blackAlpha"
        bgColor="bgSecondary"
        fontWeight="normal"
        size="sm"
      >
        <a href={`https://instagram.com/${sph.urlIg}`} target="_blank" rel="noreferrer">
          {sph.urlIg}
        </a>
      </Button>
    </Stack>
  );
}

export default WeddingLocation;
